import React, { Component } from 'react'
import history from './history'
import Firebase from 'firebase'
import {firebaseConfig} from './config'
import CacheBuster from './CacheBuster';

import { askForPermissioToReceiveNotifications } from './push-notification';

// @load components
import RouterPages from './components/RouterPages';

export default class App extends Component {
  constructor(props) {
    super(props)
    Firebase.initializeApp(firebaseConfig);
  }

  componentDidMount() {
    setTimeout(() => {
      askForPermissioToReceiveNotifications()
    }, 2000);
  }

  render() {
    return (
      <CacheBuster>
        {({loading, isLatestVersion, refreshCacheAndReload}) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }

          return (
            <RouterPages history={history} />
          )
        }}
      </CacheBuster>
    )
  }
}